import IocForms from './ioc-forms'

export default {
  install: function(Vue) {
    Vue.component(IocForms.name, IocForms)
  },
}
